<template>
  <div>
    <ModalConfirm
      @confirm="confirmDeleteItem"
      @cancel="cancelDeleteItem"
      :is-open="isModalOpen"
      :text="currentItemText"
    />
    <PageSpinner v-if="loading" />
    <div v-else class="pricelist__wrapper">
      <div class="price-item__container">
        <div v-if="email" class="add-item-btn__container">
          <button @click="$router.push('add-pricelist-item')">
            ДОБАВИ УСЛУГА
          </button>
        </div>
        <div class="main__container">
          <div class="pricelist__container">
            <table class="pricelist">
              <thead>
                <tr>
                  <td v-if="email"></td>
                  <td>Описание</td>
                  <td>Цена</td>
                  <td v-if="email"></td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in formatItems" :key="item.id">
                  <td v-if="email">
                    <button
                      @click="
                        $router.push({
                          name: 'edit-pricelist-item',
                          params: { id: item.id }
                        })
                      "
                      class="edit"
                    >
                      РЕДАКТИРАЙ
                    </button>
                  </td>
                  <td>{{ item.data.langs[$i18n.locale].text }}</td>
                  <td class="price">{{ item.data.price }}</td>
                  <td v-if="email">
                    <button
                      @click="handleDelete(item.id, item.data.langs['bg'].text)"
                      class="delete"
                    >
                      ИЗТРИЙ
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageSpinner from '@/components/widgets/PageSpinner'
import ModalConfirm from '../components/widgets/ModalConfirm'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    PageSpinner,
    ModalConfirm
  },
  name: 'Pricelist',
  data () {
    return {
      isModalOpen: false,
      currentItemText: '',
      currenItemId: null
    }
  },
  computed: {
    ...mapState('widgets', ['loading']),
    ...mapState('user', ['email']),
    ...mapState('pricelist', ['pricelist_items']),
    table () {
      return this.$t('routes.pricelist')
    },
    formatItems () {
      return this.pricelist_items.sort(
        (a, b) =>
          new Date(a.data.created.seconds) - new Date(b.data.created.seconds)
      )
    }
  },
  methods: {
    ...mapActions('pricelist', [
      'get_all_pricelist_items',
      'delete_pricelist_item'
    ]),
    handleDelete (id, text) {
      this.isModalOpen = true
      this.currenItemId = id
      this.currentItemText = `Сигурни ли сте, че искате да изтриете ${text}?`
    },
    confirmDeleteItem () {
      this.delete_pricelist_item(this.currenItemId)
      this.currenItemId = null
      this.isModalOpen = false
      this.currentItemText = ''
    },
    cancelDeleteItem () {
      this.isModalOpen = false
      this.currentItemText = ''
    }
  },
  created () {
    if (!this.formatItems.length) {
      this.get_all_pricelist_items()
    }
  }
}
</script>

<style lang="scss" scoped>
.pricelist__wrapper {
  animation-name: showWrapper;
  animation-duration: 0.5s;
}
@keyframes showWrapper {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.price-item__container {
  top: 2rem;
  text-align: center;
  button {
    padding: 2rem;
    background-color: rgb(13, 112, 0);
    border: 2px solid rgb(7, 61, 0);
    color: #fff;
    font-weight: bold;
    font-size: 1.5rem;
  }
  button.delete {
    background-color: rgb(246, 20, 20);
    border: 2px solid rgb(61, 0, 0);
  }
}
.bg {
  background: rgb(4, 158, 63);
}
.en {
  background: rgb(85, 158, 255);
}
.pl {
  background: rgb(255, 72, 72);
}
.price-item {
  padding: 1.5rem 1.5rem 1.5rem 2rem;
  font-size: 2rem;
  color: #fff;
  display: flex;
  align-items: center;
  &__container {
    margin-bottom: 4rem;
    margin-top: 3rem;
  }
  label {
    width: 10%;
    margin-right: 1rem;
  }
  input {
    width: 100%;
    font-size: 2rem;
    padding: 1rem;
  }
}
.pricelist {
  background: #fff;
  font-size: 1.5rem;
  border-collapse: collapse;
  width: 100%;
  -webkit-box-shadow: 0px 0px 5px 5px rgba(255, 255, 255, 1);
  -moz-box-shadow: 0px 0px 5px 5px rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 5px 5px rgba(255, 255, 255, 1);
  &__container {
    margin: auto;
    position: relative;
    color: rgb(100, 100, 100);
  }
  &__wrapper {
    max-width: 70%;
    margin: 2em auto 0 auto;
  }
}
.add-item-btn__container {
  background: #FFF;
  margin: 2rem;
  padding: 2rem;
}
.pricelist td,
.pricelist th {
  border: 1px solid #ddd;
  padding: 8px;
}
.pricelist th {
  text-align: center !important;
}
.pricelist thead {
  background: #646464;
  color: #fff;
}
.pricelist tbody tr {
  text-align: left;
}
.pricelist tbody tr td.price {
  text-align: center;
}
.pricelist tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}
.pricelist tbody tr:nth-child(odd) {
  background-color: #fff;
}
.pricelist th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: rgb(100, 100, 100);
  color: white;
}
.additional-tax {
  margin-top: 1.5em;
  color: rgb(228, 0, 0);
}
.prices-tax {
  text-decoration: underline;
  font-style: italic;
}
.additional-tax,
.prices-tax {
  font-family: 'Trebuchet MS', Arial, Helvetica, sans-serif;
  // margin-top: 1rem;
  text-align: center;
  padding: 1rem;
  background-color: rgba(255, 255, 255, 0.9);
}
// XX-Large devices (desktops, less than 1600px)
@media (max-width: 1598.98px) {
  .pricelist__container {
    max-width: 95%;
    //transform: translateY(0);
  }
}
// Large devices (desktops, less than 1200px)
@media (max-width: 1199.98px) {
  .pricelist {
    font-size: 1.3rem;
  }
}
// Medium devices (tablets, less than 992px)
@media (max-width: 991.98px) {
  .price-item__container {
    margin-top: 3rem;
  }
  .details {
    .th-1,
    .th-2 {
      position: relative;
      height: 5rem !important;
      display: inline-block;
      span {
        position: absolute;
        top: 50%;
      }
    }
    .th-1 {
      span {
        position: absolute;
        padding: 8px;
        left: 1rem;
        transform: translateY(-50%);
      }
    }
    .th-2 {
      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .prices-tax {
    padding-bottom: 3rem;
  }
}
// Extra small devices (portrait phones, less than 576px)
@media (max-width: 575.98px) {
  .pricelist__container {
    max-width: 100%;
  }
  .details {
    .th-1,
    .th-2 {
      height: 6.5rem !important;
      display: inline-block;
    }
  }
}
</style>
